// @ts-check
import { LBButton } from '@linearb/buzz';
import { Link } from '@material-ui/core';
import { getColor } from 'common/constants/_colors';
import { learnMorePlans } from 'common/constants/articles';
import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import { navigateBookDemoClick } from 'common/utils/utils';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import WaterCan from 'images/WaterCan.svg';
import styled from 'styled-components';

const ActionsContainer = styled(Flex)`
  border-top: 1px solid ${getColor('catskillWhite')} !important;
`;

const LearnMore = styled(Link)`
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
  font-size: 1.2rem;
`;

const UpgradeTooltip = ({ title, text = [] }) => {
  return (
    <Flex direction='column' padding='small' width='20rem'>
      <img width='60rem' height='60rem' src={WaterCan} alt='Water can' />
      <Text size='x-large' lineHeight='1.2' weight='400' mt='1rem'>
        {title}
      </Text>
      {text.map(t => (
        <Text key={t} size='medium' lineHeight='1.5' mt='1rem'>
          {t}
        </Text>
      ))}
      <LearnMore href={learnMorePlans} target='_blank'>
        Learn more about our plans {'>'}
      </LearnMore>
      <ActionsContainer pt='small'>
        <LBButton
          onClick={() => {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page: TRACKING.PAGES.METRICS,
              click_type: TRACKING.CLICK.UPGRADE_FROM_CUSTOM_DASHBOARD
            });
            navigateBookDemoClick();
          }}
        >
          Upgrade
        </LBButton>
      </ActionsContainer>
    </Flex>
  );
};

export default UpgradeTooltip;
